var map = {
	"./de/mechaName.png": "rTOA",
	"./en/mechaName.png": "5Vvi",
	"./es/mechaName.png": "DxpG",
	"./fr/mechaName.png": "BKWF",
	"./ja/mechaName.png": "d8NT",
	"./ko/mechaName.png": "/ueb",
	"./pt/mechaName.png": "jyBN",
	"./ru/mechaName.png": "YqyD",
	"./tc/mechaName.png": "sBv7",
	"./th/mechaName.png": "QsKN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lczd";